import * as React from 'react'
import { ReactElement } from 'react'
import { DisbursementOverviewDto } from '../../../config/registrationConfig'

import ViewRegistrationRow, {
    ViewRegistrationColumnProps,
    ViewRegistrationColumns,
    ViewRegistrationRowProps,
} from '../Registration/ViewRegistrationRow'
import MoneyText from '../../Text/Currency/MoneyText'
import { multiplyRate } from '../../../helpers/numberHelper'
import { Stack, StackItem, Text } from '@fluentui/react'
import { DisbursementListProps } from './DisbursementList'
import useVatType from '../../../hooks/useVatType'
import useDisbursementTypes from '../../../hooks/useDisbursementTypes'

type Props = ViewRegistrationRowProps<DisbursementOverviewDto, DisbursementListProps>
type ColumnProps = ViewRegistrationColumnProps<DisbursementOverviewDto, DisbursementListProps>

function Columns(props: ColumnProps): ReactElement {
    const { getDisbursementType } = useDisbursementTypes()
    const { vatType } = useVatType(props.item.vatType)

    switch (props.column.key) {
        case 'type':
            const disbursementType = getDisbursementType(props.item.type)
            if (disbursementType !== undefined) {
                return <Text variant="small">{disbursementType ? `${disbursementType.name}` : ''}</Text>
            }
            return null
        case 'vat':
            if (vatType !== undefined) {
                const orgVat = multiplyRate(vatType.percentage / 100, props.item.rate)
                return (
                    <Stack horizontal tokens={{ childrenGap: 0 }}>
                        <StackItem grow>
                            <Text variant="small">
                                <MoneyText value={orgVat} align="left" />
                            </Text>
                        </StackItem>
                        <StackItem>
                            <Text variant="xSmall">{vatType.percentage}%</Text>
                        </StackItem>
                    </Stack>
                )
            }
            return null
        case 'total':
            const orgTotal = multiplyRate((vatType?.percentage || 0) / 100 + 1, props.item.rate)
            return <MoneyText value={orgTotal} align="right" />
    }

    return <ViewRegistrationColumns<DisbursementOverviewDto, DisbursementListProps> {...props} />
}

export default function ViewDisbursementRow(props: Props): ReactElement {
    return <ViewRegistrationRow<DisbursementOverviewDto, DisbursementListProps> {...props} columns={Columns} />
}
